{
  "title": "Marcar consulta",
  "step": "Passo {n} de {total}",
  "back": "Voltar",
  "next": "Continuar",
  "loading": "A carregar…",
  "clinicPicker": {
    "title": "Escolha a clínica",
    "subtitle": "Selecione a sua localização preferida",
    "openingHours": "Horário",
    "noClinics": "Nenhuma clínica disponível neste momento.",
    "singleActiveAutoAdvance": "A redirecionar…",
    "browse": "Outras especialidades"
  },
  "specialtyPicker": {
    "title": "Escolha a especialidade",
    "subtitle": "Selecione a área da consulta",
    "empty": "Nenhuma especialidade disponível.",
    "otherBucket": "Outros serviços"
  },
  "atoPicker": {
    "title": "Tipo de consulta",
    "subtitle": "Escolha o serviço pretendido",
    "search": "Pesquisar serviço",
    "empty": "Sem serviços disponíveis.",
    "clinicUnavailable": "Esta clínica não aceita marcações online de momento. Por favor contacte-nos para marcar a sua consulta."
  },
  "doctorPicker": {
    "title": "Profissional",
    "subtitle": "Pode escolher um profissional ou deixar a clínica escolher por si.",
    "any": "Sem preferência",
    "anyDescription": "Mostra todos os horários de qualquer profissional disponível.",
    "empty": "Sem profissionais disponíveis para este serviço."
  },
  "nextAvailable": {
    "label": "Próxima vaga",
    "today": "Hoje",
    "tomorrow": "Amanhã",
    "loading": "A procurar a próxima vaga…",
    "none": "Sem vagas online para {service} até {date}.",
    "noneSingle": "Sem vagas online para {service} até {date}. Pode escolher outro serviço abaixo.",
    "cta": "Escolher este horário",
    "pickLabel": "Escolher este horário para {service} em {clinic}: {when}",
    "checking": "A confirmar…",
    "taken": "Esse horário acabou de ser reservado. Escolha outro horário.",
    "recapTitle": "A sua marcação",
    "recapChange": "Alterar horário",
    "searchLabel": "Tipo de consulta",
    "services": {
      "AVAL": "Avaliação inicial",
      "HOPV": "Higiene oral",
      "URG": "Urgência"
    },
    "seeOtherTimes": "Ver outros horários",
    "seeTimes": "Ver horários",
    "urgencyTitle": "Para urgências, ligue à clínica",
    "urgencyBody": "As vagas online podem não incluir as consultas de urgência que a receção consegue arranjar por telefone.",
    "urgencyCall": "Ligar para {clinic}",
    "earliest": "Mais cedo",
    "callClinic": "Ligar à clínica",
    "error": "Não foi possível verificar as vagas. Pode explorar as especialidades ou tentar novamente mais tarde."
  },
  "slotPicker": {
    "loadError": "Não foi possível carregar os horários disponíveis. Tente novamente.",
    "title": "Data e hora",
    "changeDate": "Mudar data",
    "backToTimes": "Voltar aos horários",
    "datePlaceholder": "Escolha uma data",
    "noSlots": "Sem horários disponíveis para esta data.",
    "moreDates": "Ver mais datas",
    "loadingCalendar": "A carregar calendário…",
    "loadingTimes": "A carregar horários…",
    "noAvailability": "Sem horários disponíveis nos próximos meses. Contacte-nos e encontramos uma data para si."
  },
  "form": {
    "title": "Os seus dados",
    "subtitle": "Vamos enviar a confirmação por e-mail.",
    "nameLabel": "Nome completo",
    "namePlaceholder": "O seu nome completo",
    "emailLabel": "E-mail",
    "emailPlaceholder": "exemplo@email.com",
    "phoneLabel": "Telemóvel",
    "phonePlaceholder": "+351 ___ ___ ___",
    "birthDateLabel": "Data de nascimento (opcional)",
    "reasonLabel": "Motivo (opcional)",
    "reasonPlaceholder": "O motivo da sua consulta (opcional)",
    "reasonLabelRequired": "Motivo",
    "reasonPlaceholderRequired": "O motivo da sua consulta",
    "modeLabel": "Formato da consulta",
    "modeInPerson": "Presencial",
    "modeOnline": "Online",
    "consentLabel": "Ao enviar, concorda com o tratamento dos seus dados de acordo com a nossa política de privacidade.",
    "submit": "Continuar",
    "errors": {
      "nameRequired": "Indique o seu nome.",
      "emailRequired": "Indique um e-mail válido.",
      "phoneRequired": "Indique um número de telemóvel válido.",
      "notesRequired": "Descreva brevemente o motivo da consulta.",
      "consentRequired": "É necessário aceitar a política.",
      "captchaRequired": "Conclua a verificação de segurança antes de continuar."
    },
    "marketingOptInLabel": "Quero receber dicas úteis e ofertas da clínica por email."
  },
  "verification": {
    "title": "Confirme o seu e-mail",
    "subtitle": "Enviámos um código de 6 dígitos para {email}.",
    "codeLabel": "Código de verificação",
    "submit": "Confirmar",
    "resend": "Reenviar código",
    "resendIn": "Reenviar em {seconds}s",
    "changeEmail": "Alterar e-mail",
    "checkSpam": "Não recebeu? Verifique a pasta de spam ou lixo electrónico.",
    "stillNothing": "Continua sem receber? Experimente outro e-mail ou ligue-nos — marcamos a consulta consigo.",
    "callUs": "Ligar {phone}",
    "errors": {
      "invalid": "Código inválido. Tente novamente.",
      "expired": "O código expirou. Peça um novo.",
      "tooManyAttempts": "Demasiadas tentativas. Peça um novo código."
    }
  },
  "summary": {
    "title": "Revisão da marcação",
    "notBooked": "A sua consulta ainda não está marcada.",
    "instructions": "Reveja os dados e prima «{button}» no final desta página para concluir.",
    "service": "Serviço",
    "doctor": "Profissional",
    "datetime": "Data e hora",
    "patient": "Doente",
    "edit": "Editar",
    "confirm": "Confirmar marcação"
  },
  "confirmation": {
    "title": "Marcação confirmada",
    "subtitle": "Receberá um e-mail com os detalhes.",
    "reference": "Referência",
    "startOver": "Marcar nova consulta"
  },
  "cancel": {
    "title": "Cancelar consulta",
    "failedContactClinic": "O cancelamento online não foi confirmado. Contacte a clínica para cancelar a consulta.",
    "windowExpired": "Não é possível cancelar online com menos de {hours} horas.",
    "reasonLabel": "Motivo (opcional)",
    "confirmButton": "Cancelar consulta"
  },
  "errors": {
    "slotTaken": "Esse horário já não está disponível. Escolha outro.",
    "verificationRequired": "É necessário verificar o e-mail antes de confirmar.",
    "captchaFailed": "A verificação de segurança falhou. Tente novamente.",
    "generic": "Algo correu mal. Tente novamente."
  },
  "unavailable": {
    "title": "Marcação temporariamente indisponível",
    "subtitle": "Estamos a configurar este sistema. Tente novamente em breve."
  },
  "outage": {
    "title": "Marcação online temporariamente indisponível",
    "body": "Não estamos a conseguir ligar ao sistema de marcações. Ligue-nos e marcamos a sua consulta de imediato.",
    "bodyNoPhone": "Não estamos a conseguir ligar ao sistema de marcações. Contacte a clínica por telefone para marcar a sua consulta, ou tente novamente dentro de momentos.",
    "call": "Ligar",
    "retry": "Tentar novamente"
  },
  "steps": {
    "clinic": {
      "title": "Clínica",
      "description": "Selecione a sua localização"
    },
    "specialty": {
      "title": "Especialidade",
      "description": "Área da consulta"
    },
    "ato": {
      "title": "Serviço",
      "description": "Escolha o tipo de consulta"
    },
    "doctor": {
      "title": "Profissional",
      "description": "Escolha o seu profissional"
    },
    "slot": {
      "title": "Horário",
      "description": "Escolha a data e hora"
    },
    "summary": {
      "title": "Confirmar",
      "description": "Reveja e confirme"
    }
  },
  "quickSteps": {
    "chosen": "Consulta escolhida",
    "details": "Os seus dados",
    "confirm": "Confirmação"
  },
  "manage": {
    "cancelContactClinic": "Para cancelar ou alterar esta consulta, contacte a clínica.",
    "title": "Olá {name}",
    "intro": "A sua próxima consulta:",
    "when": "Quando",
    "doctor": "Médico",
    "service": "Serviço",
    "clinic": "Clínica",
    "cancelAndRebookHint": "Precisa de outro horário? Cancele abaixo e marque uma nova consulta — ou ligue para a clínica.",
    "windowExpired": "Já não pode alterar esta consulta online (faltam menos de {hours}h para o início).",
    "windowExpiredHint": "Ligue para a clínica para cancelar ou alterar a consulta.",
    "notFoundTitle": "Consulta não encontrada",
    "notFoundBody": "Este link pode estar expirado ou inválido. Se precisar de ajuda, contacte a clínica diretamente.",
    "alreadyCancelledTitle": "Consulta cancelada",
    "alreadyCancelledBody": "Esta consulta já foi cancelada — não é necessária qualquer ação.",
    "cancelledNowTitle": "A sua consulta foi cancelada",
    "cancelledNowBody": "Obrigado por nos avisar — o horário fica livre para outro paciente.",
    "bookAgainCta": "Marcar nova consulta",
    "notCancellableTitle": "Esta consulta já não pode ser alterada",
    "notCancellableBody": "Por favor contacte a clínica se precisar de ajuda."
  },
  "search": {
    "title": "Encontrar a próxima vaga",
    "subtitle": "Compare horários entre clínicas",
    "heading": "A sua próxima consulta",
    "intro": "Compare os horários e escolha o que lhe dá mais jeito.",
    "clinic": "Clínica",
    "allClinics": "Todas as clínicas",
    "consultation": "Consulta",
    "selectedConsultation": "Tratamento selecionado",
    "searchConsultation": "Pesquisar consulta…",
    "chooseConsultation": "Escolha uma consulta",
    "closeConsultations": "Fechar consultas",
    "showConsultations": "Mostrar todas as consultas",
    "consultationTypes": "Tipos de consulta",
    "noConsultations": "Nenhuma consulta encontrada. Experimente outro termo.",
    "automatic": "As vagas atualizam ao escolher a consulta.",
    "results": "Próximas vagas",
    "clinicCount": "{count, plural, =0 {0 clínicas} one {# clínica} other {# clínicas}}",
    "guidance": "Escolha um horário ou abra o calendário da clínica para ver todas as datas disponíveis.",
    "backToClinics": "Voltar à escolha de clínica",
    "anyDoctor": "Sem preferência de profissional",
    "browseTimes": "Mais horários em {clinic}",
    "previousLabel": "Anterior: horário em {clinic}",
    "nextLabel": "Seguinte: horário em {clinic}",
    "previous": "Anterior",
    "next": "Seguinte",
    "position": "Horário {number}",
    "noLater": "Não há mais vagas no período pesquisado.",
    "bookLabel": "Marcar às {time}, {day}, {clinic}",
    "bookAt": "Marcar às {time}",
    "noClinics": "Não encontrámos vagas online para esta consulta nas próximas semanas. Escolha outra consulta ou volte à lista de clínicas.",
    "notOffered": "Esta consulta não está disponível nesta clínica.",
    "otherConsultations": "Ver outras consultas",
    "retry": "Tentar novamente",
    "calendar": "Ver calendário",
    "calendarLabel": "Ver todas as datas disponíveis em {clinic}",
    "bookingMode": "Como pretende marcar?",
    "nextAvailableMode": "Próxima vaga",
    "clinicFirstMode": "Escolher clínica",
    "consultationFirstMode": "Escolher consulta",
    "change": "Alterar",
    "done": "Concluir",
    "commonAppointments": "Consultas frequentes",
    "dentalTreatments": "Tratamentos dentários",
    "otherTreatments": "Outros tratamentos",
    "earliestFirst": "Mais cedo primeiro",
    "earliestAvailable": "Vaga mais próxima",
    "chooseAppointment": "Marcar",
    "moreTimes": "Mais horários"
  },
  "doctorBooking": {
    "with": "Marcação com {name}",
    "unavailable": "Não há consultas disponíveis para marcação online com este profissional nas clínicas selecionadas.",
    "seeAll": "Ver todas as consultas"
  },
  "intake": {
    "title": "O que o traz à clínica?",
    "subtitle": "Descreva em poucas palavras e sugerimos a consulta certa.",
    "label": "Descreva o seu problema ou o motivo da marcação",
    "placeholder": "Ex.: tenho um dente a doer há dois dias · quero fazer uma limpeza com o cheque-dentista · o meu filho precisa de aparelho",
    "privacy": "Usamos esta descrição apenas para sugerir o tipo de consulta e para informar a equipa. Não substitui uma avaliação clínica.",
    "submit": "Sugerir a consulta certa",
    "suggesting": "A analisar…",
    "browseAll": "Prefiro escolher na lista",
    "resultTitle": "Sugerimos esta consulta:",
    "recommended": "Recomendada",
    "notThis": "Não é isto — ver todos os serviços",
    "rephrase": "Descrever de outra forma",
    "unclear": "Não conseguimos identificar a consulta a partir da descrição. Escolha na lista ou descreva de outra forma.",
    "emergency": "Se tiver uma hemorragia que não para, um traumatismo na face ou dificuldade em respirar ou engolir, ligue 112 ou dirija-se a uma urgência hospitalar agora.",
    "offeredAt": "Disponível em: {clinics}",
    "chooseClinicFor": "Onde prefere marcar a consulta de {service}?"
  }
}
